<template>
  <modal 
    @before-close="modalClose" 
    @before-open="modalOpen" 
    :name="`${this.modal}`" 
    :adaptive="true"
    :clickToClose="false" 
    :reset="true" 
    :scrollable="true" 
    :height="'auto'" 
    :width="1000"
		>
		
    <div style="background-color: white; border-radius: 10px; overflow: hidden;">
			<div class="stops-content" v-if="stops[lang] && stops[lang].length">
				<ul>
					<li v-for="(item, key) in stops[lang]" :key="key">
						<span class="circle" :style="`color: ${item.color}`"></span>
						{{item.name}} - {{ item.distance }}
					</li>
				</ul>
			</div>
      <div style="
				height: 80vh; 
				min-height: 300px;
				max-height: 800px;
				width: 100%; 
				overflow:hidden; 
				">
        <l-map 
          v-if="showMap" 
          :zoom="zoom" 
          :center="center" 
          :options="mapOptions" 
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate" 
          @click="clickMap">
          <l-tile-layer :url="url" :attribution="attribution" />

          <l-marker v-if="positions" :lat-lng="positions">
            <l-popup>
              <div >
                <h5><b>{{item.name}}</b></h5>
								<p class="my-2" v-if="lang">
									<b>Адрес:</b> {{ item[`address:${lang}`] }}
								</p>
                <div class="my-2" v-if="item.description">
                  Ориентир:  {{item.description}}
								</div>
                <div v-if="item.dealer" class="mt-2 mb-3">
                	<b>Организация:</b> {{item.dealer.llc_name}} <Br/>
                  <b>Владелец:</b> {{item.dealer.full_name}} <Br/>
                  <b>Номер телефона:</b> <a class="ml-1" :href="`tel:${item.dealer.phone}`">{{item.dealer.phone}}</a><Br/>
								</div>
								<a 
									:href="`https://yandex.uz/maps/10335/tashkent/search/${encodeURIComponent(item[`address:${lang}`])}/?z=13`" 
									target="_blank" 
									rel="noopener noreferrer">
									<img class="mr-1" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxOCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI0Y0MyIgZD0iTTcgMGE3IDcgMCAwIDAtNC45NSAxMS45NWMxLjI3IDEuMjcgNC4yNSAzLjEgNC40MiA1LjAzLjAzLjI4LjI0LjUyLjUzLjUyLjI5IDAgLjUtLjI0LjUzLS41Mi4xNy0xLjkzIDMuMTUtMy43NiA0LjQyLTUuMDNBNyA3IDAgMCAwIDcgMHoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNyA5LjQ1YTIuNDUgMi40NSAwIDEgMCAwLTQuOSAyLjQ1IDIuNDUgMCAwIDAgMCA0Ljl6Ii8+PC9zdmc+">
									Открыть в картах
								</a>
              </div>
            </l-popup>
          </l-marker>

          <template v-if="polyline.latlngs.length">
            <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color" />
          </template>

        </l-map>
      </div>
			<div class="d-flex justify-content-end p-3">
				<div v-if="lang" class="w-100 px-3 d-flex align-items-center" >
					{{ item[`address:${lang}`] }}
				</div>
        <p-button 
          class="btn-sm  mr-2" 
          @click.native.prevent="closeModal" 
          style="display: flex; align-items: center;">
					<span style="text-transform: none;">Назад</span>
        </p-button>
        <p-button 
          class="btn-sm mr-2" 
					type="success"
          @click.native.prevent="closeModal" 
          style="display: flex; align-items: center;">
					<span style="text-transform: none;">Готово</span>
        </p-button>
			</div>

    </div>
  </modal>
</template>
<script>

import { mapState } from 'vuex';
import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolyline } from "vue2-leaflet";
Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
import 'leaflet/dist/leaflet.css';
export default {
	computed: {
		...mapState(["lastUpdate"]),
	},
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
		LTooltip,
		LPolyline
	},
	// name: "products",
	props: {
		item: Object,
    modal: String,
		defaultLat: {
			default: 41.311081
		},
		defaultLon: {
			default: 69.240562
		},
		polyline: {
			default: function () {
				return {
					latlngs: [],
					color: "green"
				};
			}
		},
	},
	mounted() {
		this.langs.forEach((e)=>{
			this.createrMap(e)
		})
		if(this.item.lat && this.item.lon){
			this.positions = latLng({lat: this.item.lat, lon: this.item.lon})
			this.center = latLng({lat: this.item.lat, lon: this.item.lon})
		}
	},
	methods: {
		clickMap(event) {
			this.positions = event.latlng
			this.item.lat = event.latlng.lat
			this.item.lon = event.latlng.lng
			this.searchLocation(this.item.lat, this.item.lon)
		},
		searchLocation(lat, lon){
			Object.values(ymapsObjects).forEach((el)=>{
				el.searchControl.search(`${lat}, ${lon}`);
			})
		},
		createrMap(lang){
			const that = this
			if(!window.ymapsObjects)
				window.ymapsObjects = {}
			window.ymapsObjects[lang] = {}
			
			let mapEl = document.createElement('div')
			mapEl.setAttribute("id", 'ymap-'+lang)
			mapEl.setAttribute("style", 'display: none;')
			document.body.append(mapEl)

			let elScript = document.createElement('script')
			let apikey = 'f06d738e-1a2e-4ca2-91cc-d23a3bbb9e09'
			let localLang = `${lang}_${lang.toUpperCase()}`
			let link = `https://api-maps.yandex.ru/2.1/?lang=${localLang}&apikey=${apikey}`
			elScript.setAttribute('src', link)
			document.head.appendChild(elScript).onload = function(){
				ymapsObjects[lang].ymaps = ymaps
				ymapsObjects[lang].ymaps.ready(()=>{that.init(lang, ymapsObjects[lang])});
				delete window.ymaps
			}
		},
		init(lang, langObj){
			const that = this
			// console.log(ymapsObjects[lang], lang)
			langObj.el = new langObj.ymaps.Map(`ymap-${lang}`, {center: [41.30, 69.28], zoom: 13});
			langObj.searchControl = new langObj.ymaps.control.SearchControl({options: {provider: 'yandex#search'}});

			langObj.el.controls.add(langObj.searchControl);
			langObj.searchControl.events.add("load", function(e){
				let properties = langObj.searchControl.getResultsArray()[0].properties.getAll()
				let address = properties.address
				console.log(properties, properties.stops)
				that.stops[lang] = properties.stops
				that.item['address:'+lang] = address
			})
			delete window.ymaps
		},
		zoomUpdate(zoom) {
			this.currentZoom = zoom;
		},
		centerUpdate(center) {
			this.currentCenter = center;
		},
    //modal
    modalClose() {},
    modalOpen(modal) {
			try {
				this.lang = modal.params.lang	
			} catch (error) {}
		},
    closeModal() {
      this.$modal.hide(`${this.modal}`);
    },


	},
	data() {
		return {
			zoom: 13,
			center: latLng(this.defaultLat ? this.defaultLat : 41.311081, this.defaultLon ? this.defaultLon : 69.240562),
			currentCenter: latLng(this.defaultLat ? this.defaultLat : 41.311081, this.defaultLon ? this.defaultLon : 69.240562),
			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			attribution: '',
			currentZoom: 11.5,
			showParagraph: false,
			lang: "ru",
			langs: ['ru', 'uz'],
			stops: {},
			mapOptions: {
				zoomSnap: 0.5
			},
			showMap: true,
			positions: null,
		};
	},
};
</script>
<style lang="scss">
.leaflet-control,
.leaflet-popup-close-button {
	opacity: 0;
}
.stops-content{
	pointer-events: none;
	position: absolute;
	left: 30px;
	top: 30px;
	z-index: 1111;
	background-color: white;
	border-radius: 10px;
	padding: 20px;
	li{
		font-size: 13px;
		display: flex;
		align-items: center;
	}
	.circle{
		border-radius: 50%;
		margin-right: 8px;
		width: 5px;
		height: 5px;
		display: inline-block;
		background-color: currentColor;
	}
}
</style>
  